import {useState, useEffect, useRef} from 'react';
import {Linking} from 'react-native';
import {useSelector, useDispatch} from 'react-redux';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {showMessage} from 'react-native-flash-message';
import {fetchData, handlePrinterSelection} from '../../../../qzservice';
import {reset, setPostScanPipeline} from '../../../actions/scanpackScanningActions';
import {initialPostScanPipeline} from '../../../reducers/scanpackScanningInitialState';
import * as RootNavigation from '../../root_navigation';

const showPrintError = message =>
  showMessage({message, type: 'danger', duration: 8000});

const useDirectPrint = () => {
  const dispatch = useDispatch();
  const directPrintPending = useSelector(
    state => state.scanPackScanning.postScanPipeline.directPrintPending
  );

  const [modalVisible, setModalVisible] = useState(false);
  const [printers, setPrinters] = useState([]);
  const printParamsRef = useRef(null);

  useEffect(() => {
    if (!directPrintPending) return;

    const {printUrl, dimensions, settings} = directPrintPending;
    printParamsRef.current = {printUrl, dimensions, settings};

    const initPrint = async () => {
      try {
        const data = await fetchData();
        const printersList = JSON.parse(
          JSON.stringify(data?.printersList || [])
        );

        const savedPrinter =
          (await AsyncStorage.getItem('print_ss_shipping_labels')) || '';

        if (savedPrinter.length > 0) {
          await handlePrinterSelection(
            JSON.parse(savedPrinter),
            printUrl,
            settings,
            'shipping_label',
            dimensions,
            null,
            showPrintError
          );
          navigateBack();
        } else if (printersList.length > 0) {
          setPrinters(printersList);
          setModalVisible(true);
        } else {
          Linking.openURL(printUrl);
          navigateBack();
        }
      } catch (e) {
        showPrintError(
          `Printing failed. The label opened in a new tab for manual printing. ${e?.message || ''}`.trim()
        );
        Linking.openURL(printUrl);
        navigateBack();
      }

      clearPendingSignal();
    };

    initPrint();
  }, [directPrintPending]);

  const clearPendingSignal = () => {
    dispatch(
      setPostScanPipeline({
        ...initialPostScanPipeline,
        directPrintPending: null,
      })
    );
  };

  const navigateBack = () => {
    dispatch(reset());
    RootNavigation.reset('ScanPack');
  };

  const onPrinterSelect = async printer => {
    const params = printParamsRef.current;
    if (params) {
      await handlePrinterSelection(
        printer,
        params.printUrl,
        params.settings,
        'shipping_label',
        params.dimensions,
        null,
        showPrintError
      );
    }
    setModalVisible(false);
    setPrinters([]);
    printParamsRef.current = null;
    navigateBack();
  };

  const onCloseModal = () => {
    setModalVisible(false);
    setPrinters([]);
    printParamsRef.current = null;
    navigateBack();
  };

  return {
    printerModalVisible: modalVisible,
    printerList: printers,
    onPrinterSelect,
    onCloseModal,
  };
};

export default useDirectPrint;
